
jQuery( document ).ready( function( $ ) {
    subMenuImages();
    menuFixed();
    cerrarBuscador();
    //console.log('lo hace?');
    enlaceFake();
}); 

function subMenuImages() { 
    $('#top-menu li.category a.imagen').mouseover(function(e){
        var image_url = $(this).data('image');
        //console.log('img url: '+image_url);
        if(typeof image_url !== 'undefined'){
            var image = '<img src="'+$.trim(image_url)+'">';
            //console.log('image: '+image);
            $('.sub-menu .submenu-image .menu-image-wrapper').empty();
            $('.sub-menu .submenu-image .menu-image-wrapper').append(image);
        }
    });
}

function menuFixed() {
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        //var headerHeight = $('.header-top').height();
        if (scroll >= 40) {
            $(".header-top").addClass("fixed");
        }else {
            $(".header-top").removeClass("fixed");
        }
    });
}

function cerrarBuscador() {
    $('#header .search-widget-input .cerrar-buscador').click(function(e){
       $('#header .search-widget-input').addClass('hidden');
        $('#header .showBlockSearch').removeClass('active');
    });
}

function enlaceFake() {
    $('.fake-a').on('click',function(e){
        var url = $(this).find('a')[0].href;
        if ($(this).find('a')[0].target =='_blank') {
            window.open(url, '_blank');
        }else {
            document.location.href=url;
        }
    });
}


// WEBPACK FOOTER //
// ./js/custom.js